import HeaderAlerts from '../headerAlerts';
import LayoutCheckbox from '../forms/layoutCheckbox';
import LayoutSelect from '../forms/layoutSelect';
import Medusa from 'medusajs';
import Modal from './modal';
import PropTypes from 'prop-types';
import React from 'react';
import events from 'lib/events';
import session from 'services/sessionService';
import {languages, allowTranslations} from 'helpers/languageHelper';
import {FormattedMessage, injectIntl, intlShape} from 'react-intl';

class NavBarAccountMenu extends React.Component {
  static propTypes = {
    intl: intlShape.isRequired,
    openBranchModal: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    let branches = session.getMyBranches();

    this.state = {
      accountShow: false,
    };
  }

  //Avoid re-render navbar after every click within website window
  shouldComponentUpdate(nextProps, nextState) {
    return this.props.intl !== nextProps.intl ||
    this.props.intl && nextProps.intl && this.props.intl.locale !== nextProps.intl.locale ||
    this.state.accountShow !== nextState.accountShow;
  }

  componentWillUnmount() {
    if (this._eventHideAccountActivate) {
      clearTimeout(this._eventHideAccountActivate);
    }
    if (this._eventHideAccount) {
      this._eventHideAccount.remove();
    }
  }

  _eventHideAccount = null;
  _eventHideAccountActivate = null;

  accountOptionsHide = (e) => {

    this.setState({accountShow: false});

    if (this._eventHideAccount) {
      this._eventHideAccount.remove();
    }

  };

  accountOptionsShow = (e) => {
    e.preventDefault();

    this.setState({accountShow: true});

    if (this._eventHideAccount) {
      this._eventHideAccount.remove();
    }

    let self = this;

    this._eventHideAccountActivate = setTimeout(() => {
      self._eventHideAccount = events.subscribe('click', self.accountOptionsHide);
    }, 10);
  };

  downgrade = () => {
    let user = session.getUser();
    let branches = user.privileges.branches || [];

    if (branches.length === 0) {
      branches = session.getMyBranches() || [];
    }
    if (branches.length > 0) {
      this.props.openBranchModal();
    } else {
      session.downgrade();
    }
  };

  logout = (e) => {
    e.preventDefault();

    if (window.keepAliveTimeout) {
      clearTimeout(window.keepAliveTimeout);
    }

    if (window.keepAliveInterval) {
      clearInterval(window.keepAliveInterval);
    }

    session.invalidateSession();
    session.nuke();
    Medusa.clear(); // NOTE: this clears all of localStorage not just the keys set in medusa

    console.log('nuking localstorage');

    window.location.href = '/Login/Logout';
  };

  toggleTitrationTestMode = (e) => {
    session.toggleTitrationTestMode();
  };

  toggleTitrationTestModeClickMenuItem = (e) => {
    e.preventDefault();
    e.stopPropagation();
    session.toggleTitrationTestMode();
    this.setState({accountShow: false});
  };

  handleOnClick = (e, condition, method) => {
    if (condition) {
      method(e);
    }

  };

  render() {
    let accountOptions = null;
    let user = session.getUser();
    let canDowngrade = !user.downgraded && user.privileges.level > 1000;
    let canUpgrade = user.downgraded && user.privileges.level === 1000;
    let languageItems = [];
    let locale = this.props.intl.locale;

    Object.keys(languages).forEach((key) => {
      languageItems.push(
        <a key={'link-language-' + key} onClick={() => events.publish('set.language', key)}>
          <LayoutCheckbox label={<FormattedMessage id={languages[key].label}/>}
                          dataKey={'language-' + key}
                          key={'language-' + key}
                          value={key === locale}/>
        </a>
      );
    });

    if (this.state.accountShow) {
      let accountStyle = {
        display: 'block',
        width: '260px',
        top: '42px',
        left: '-10px',
      };

      accountOptions = <div className='popover bottom fade in'
                            style={accountStyle}>
        <div className='arrow'
             style={{left: '90%'}}/>
        <div className='popover-content account'>
          <div className='welcome-menu-item'>
            <a onClick={(e) => this.handleOnClick(e, canDowngrade, this.downgrade)}>
              <LayoutCheckbox label={<FormattedMessage id='navbar.test.station.mode'/>}
                              dataKey='canDowngrade'
                              key='canDowngrade'
                              value={!canDowngrade}/>
            </a>
            {canUpgrade ? <a onClick={(e) => this.handleOnClick(e, canUpgrade, this.logout)}>
              <LayoutCheckbox label={<FormattedMessage id='navbar.admin.mode'/>}
                              dataKey='canUpgrade'
                              key='canUpgrade'
                              value={!canUpgrade}/>
            </a> : null}
          </div>
          {allowTranslations ?
            <div className='welcome-menu-item'>
              {languageItems}
            </div> : null}
          <div className='welcome-menu-item'>
            <a onClick={(e) => this.handleOnClick(e, user.titrationTestingOnly === false, this.toggleTitrationTestModeClickMenuItem)}>
              <LayoutCheckbox label={<FormattedMessage id='navbar.tritration'/>}
                              dataKey='titrationTestingOnly'
                              key='titrationTestingOnly'
                              onChange={this.toggleTitrationTestMode}
                              value={user.titrationTestingOnly}/>
            </a>
            <a onClick={(e) => this.handleOnClick(e, user.titrationTestingOnly === true, this.toggleTitrationTestModeClickMenuItem)}>
              <LayoutCheckbox label={<FormattedMessage id='navbar.connected.test.device'/>}
                              dataKey='notTitrationTestingOnly'
                              key='notTitrationTestingOnly'
                              onChange={this.toggleTitrationTestMode}
                              value={!user.titrationTestingOnly}/>
            </a>
          </div>
          <div className='welcome-menu-item'>
            <a href='#'
               onClick={this.logout}
               data-event-category='User'
               data-event-action='signout'>
              <i className='fa fa-sign-out fa-lg'/>
              <span className='single-label'><FormattedMessage id="navbar.logout"/></span>
            </a>
          </div>
        </div>
      </div>;
    }

    return <React.Fragment>
      <a href='#me'
                 onClick={this.accountOptionsShow}>
        <i className='icon bl bl-profile'/>
                &nbsp;&nbsp;
        <FormattedMessage id="navbar.welcome"/> {user.downgraded ?
          <FormattedMessage id="navbar.test.station.user"/> :
                user.name}
                &nbsp;&nbsp;
        <i id='logout-dropdownleft'
                   className='bl bl-dropdown'/>
      </a>
      {accountOptions}
    </React.Fragment>;
  }
}

export default injectIntl(NavBarAccountMenu);